import { render } from "./productivity_improvement_program.vue?vue&type=template&id=e477a7e0&scoped=true"
import script from "./productivity_improvement_program.vue?vue&type=script&lang=js"
export * from "./productivity_improvement_program.vue?vue&type=script&lang=js"

import "./productivity_improvement_program.vue?vue&type=style&index=0&id=e477a7e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e477a7e0"]])

export default __exports__